<nz-tree-select
	style="width: 500px"
	[nzNodes]="nodes"
	[nzAllowClear]="false"
	[nzExpandedKeys]="expandedKeys"
	nzShowSearch
	nzPlaceHolder="Please select"
	[(ngModel)]="selectedId"
	(ngModelChange)="change($event)"/>
